import {initHeaderScrollShadow} from "../../../js/util/HeaderUtils.js";

export default class PostPageHeaderHtml {
    #root;

    init(headerEl) {
        this.#root = headerEl;
        initHeaderScrollShadow(headerEl);
    }

    /** @returns {HTMLElement} */
    getUserHeaderElement() {
        return this.#root.querySelector('.page-header__section--user');
    }

    /** @returns {HTMLElement} */
    getBreadcrumbsElement() {
        return this.#root.querySelector('.page-header__breadcrumbs-section');
    }
}